(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["sticky-image-with-text"] && !Shopify.designMode) return;
  try {
    
  class StickyImageWithText extends HTMLElement {
    connectedCallback() {
      this.media = this.querySelector('.sticky-image-with-text__media');
      if (!this.media) return;

      this.updateMediaHeight = this.updateMediaHeight.bind(this);
      this.updateMediaHeight();

      if ('ResizeObserver' in window) {
        this.resizeObserver = new ResizeObserver(this.updateMediaHeight);
        this.resizeObserver.observe(this.media);
      } else {
        window.addEventListener('resize', this.updateMediaHeight, { passive: true });
        window.addEventListener('load', this.updateMediaHeight, { once: true });
      }
    }

    updateMediaHeight() {
      const mediaHeight = this.media?.getBoundingClientRect().height || 0;
      if (mediaHeight > 0) {
        this.style.setProperty('--sticky-media-height', `${mediaHeight}px`);
      }
    }

    disconnectedCallback() {
      this.resizeObserver?.disconnect();
      window.removeEventListener('resize', this.updateMediaHeight);
    }
  }

  if (!customElements.get('sticky-image-with-text')) {
    customElements.define('sticky-image-with-text', StickyImageWithText);
  }

  } catch(e) { console.error(e); }
})();
})();
